<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import WasteTab from "@/views/pages/project/sale/waste.vue";
import WorkTab from "@/views/pages/project/sale/work.vue";
import EstimateTab from "@/views/pages/project/sale/estimate.vue";
import ContractTab from "@/views/pages/project/sale/contract.vue";
import WorkOrderTab from "@/views/pages/project/sale/work_order.vue";
import ProjectInfo from "@/views/pages/project/sale/project_info.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  page() {
    return {
      title: this.c_type_tab,
      meta: [{ name: "description", content: appConfig.description }]
    }
  },
  components: {
    Layout,
    WasteTab,
    WorkTab,
    EstimateTab,
    ContractTab,
    WorkOrderTab,
    ProjectInfo
  },
  computed: {
    c_type_tab() {
      let result = ''
      switch (this.activeTabIndex) {
        case 0:
          result = '廃棄物一覧'
          break;
        case 1:
          result = 'サービス一覧'
          break;
        case 2:
          result = '見積一覧'
          break;
        case 3:
          result = '契約一覧'
          break;
        case 4:
          result = '作業指示一覧'
          break;
        default:
          result = ''
      }
      return result;
    }
  },
  created() {
    this.getData();
  },
  data() {
    return {
      activeTabIndex: Number(this.$route.query.activeTabIndex)
        ? Number(this.$route.query.activeTabIndex)
        : this.$constant.pages.project.sales.waste.tabIndex,
      isLoading: false,
      projectInfos: null
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;

      const url = apiEndpoints.projects_sales.replace(
        ":id",
        this.$route.params.id
      );
      const sendApiProject = await this.$http.get(url, {});
      const { status, data } = sendApiProject;

      if (status) {
        this.projectInfos = data.result;
      }

      this.isLoading = false;
    },
    onGetDataInsideTab(status) {
      if (status) return this.displayLoading();

      return this.hideLoading();
    },
    displayLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },
    isActive(index) {
      return Number(this.activeTabIndex) === index;
    },
    onChangeTab(newTabIndex, prevTabIndex, bvEvent) {
      bvEvent.preventDefault();
      this.$router.replace({
        query: {
          activeTabIndex: newTabIndex
        }
      });
    },
    backToList() {
      let query =
        localStorage.getItem("projects") == null
          ? {}
          : JSON.parse(localStorage.getItem("projects"));
      this.$router.push({
        name: "projects",
        query: query
      });
    }
  }
};
</script>

<template>
  <Layout>
    <b-row>
      <b-card class="mb-1">
        <ProjectInfo :data="projectInfos" @redirectBackToList="backToList()"/>
      </b-card>
    </b-row>
    <b-row :class="['remove-padding']">
      <b-card class="tab-custom" no-body>
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-tabs
            card
            justified
            @activate-tab="onChangeTab"
            :value="activeTabIndex"
          >
            <b-tab title="廃棄物">
              <WasteTab
                @get-data="onGetDataInsideTab"
                :activeTabIndex="activeTabIndex"
                v-if="
                  this.isActive(
                    projectInfos &&
                      this.$constant.pages.project.sales.waste.tabIndex
                  )
                "
              />
            </b-tab>
            <b-tab title="サービス">
              <WorkTab
                @get-data="onGetDataInsideTab"
                :activeTabIndex="activeTabIndex"
                v-if="
                  this.isActive(
                    projectInfos &&
                      this.$constant.pages.project.sales.work.tabIndex
                  )
                "
              />
            </b-tab>
            <b-tab title="見積">
              <EstimateTab
                @get-data="onGetDataInsideTab"
                :activeTabIndex="activeTabIndex"
                v-if="
                  this.isActive(
                    projectInfos &&
                      this.$constant.pages.project.sales.estimate.tabIndex
                  )
                "
              />
            </b-tab>
            <b-tab title="契約">
              <ContractTab
                @get-data="onGetDataInsideTab"
                :activeTabIndex="activeTabIndex"
                v-if="
                  this.isActive(
                    projectInfos &&
                      this.$constant.pages.project.sales.contract.tabIndex
                  )
                "
              />
            </b-tab>
            <b-tab title="作業指示">
              <WorkOrderTab
                @get-data="onGetDataInsideTab"
                :activeTabIndex="activeTabIndex"
                :disableEntry="(projectInfos.customer_id == 0 || projectInfos.discharger_id == 0 || projectInfos.discharger_site_id == 0)"
                v-if="
                  this.isActive(
                    projectInfos &&
                      this.$constant.pages.project.sales.instruction.tabIndex
                  )
                "
              />
            </b-tab>
          </b-tabs>
        </b-overlay>
      </b-card>
    </b-row>
  </Layout>
</template>
